__webpack_require__.p = "/KT21Calculator/";